// Endpoints shared by the app shell and more than one module.
// Endpoints used by a single module live in that module's api.js.
import { request, apiUrl, guestHeaders, authHeaders } from './index';

// lookup config
export function getLookup() {
    return request({
        url: apiUrl('global/lookup'),
        method: 'get',
        headers: guestHeaders()
    });
}

// merchant info (public, no login required) - used to detect active template
export function getMerchantInfo() {
    return request({
        url: apiUrl('global/merchantInfo'),
        method: 'get',
        headers: guestHeaders()
    });
}

// country list
export function getCountryList() {
    return request({
        url: apiUrl('global/country_list'),
        method: 'get',
        headers: guestHeaders()
    });
}

// request otp (guest, before login - e.g. register, forgot password)
export function requestOTP(mobile_no) {
    return request({
        url: apiUrl('auth/requestOTP'),
        method: 'post',
        data: { mobile_no },
        headers: guestHeaders()
    });
}

// request otp (logged-in member - e.g. change password, withdrawal)
export function requestUserOTP() {
    return request({
        url: apiUrl('member/requestUserOTP'),
        method: 'post',
        headers: authHeaders()
    });
}

// logout
export function logout() {
    return request({
        url: apiUrl('auth/logout'),
        method: 'post',
        headers: authHeaders()
    });
}

// member
export function getMemberInfo() {
    return request({
        url: apiUrl('member/get-member-info'),
        method: 'get',
        headers: authHeaders()
    });
}

export function updateMemberInfo(data) {
    return request({
        url: apiUrl('member/update-member-info'),
        method: 'post',
        data,
        headers: authHeaders()
    });
}

// user bank - get list
export function getBankInfo() {
    return request({
        url: apiUrl('member/get-bank-info'),
        method: 'get',
        headers: authHeaders()
    });
}

// my reward
export function getMyReward() {
    return request({
        url: apiUrl('reward/getMyReward'),
        method: 'get',
        headers: authHeaders()
    });
}
